import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import AnalyticsCard from './AnalyticsCard';

const RADIAN = Math.PI / 180;
function PctLabel({ cx, cy, midAngle, innerRadius, outerRadius, percent }) {
  const r = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + r * Math.cos(-midAngle * RADIAN);
  const y = cy + r * Math.sin(-midAngle * RADIAN);
  return (
    <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" fontSize={12} fontWeight={600}>
      {(percent * 100).toFixed(1)}%
    </text>
  );
}

const fmt = (n) => (n >= 1e6 ? (n / 1e6).toFixed(1) + 'M' : n >= 1e3 ? (n / 1e3).toFixed(1) + 'K' : n);

export default function PartsChart({ data, kpis }) {
  return (
    <AnalyticsCard title="Parts Identified vs Not">
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} labelLine={false} label={PctLabel}>
            {data.map((d, i) => <Cell key={i} fill={d.fill} />)}
          </Pie>
          <Tooltip formatter={(v) => v.toLocaleString()} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
        </PieChart>
      </ResponsiveContainer>
      <div className="grid grid-cols-2 gap-3 mt-3">
        <div className="rounded-lg p-3 text-center" style={{ background: '#3b82f618' }}>
          <p className="text-lg font-bold" style={{ color: '#3b82f6' }}>{fmt(kpis.partsIdentified)}</p>
          <p className="text-xs text-text-secondary font-medium mt-0.5">Identified</p>
        </div>
        <div className="rounded-lg p-3 text-center" style={{ background: '#f9731618' }}>
          <p className="text-lg font-bold" style={{ color: '#f97316' }}>{fmt(kpis.partsNotIdentified)}</p>
          <p className="text-xs text-text-secondary font-medium mt-0.5">Not Identified</p>
        </div>
      </div>
    </AnalyticsCard>
  );
}
